<template>
  <div>
    <b-card>
      <b-row>
        <b-col
          cols="12"
          md="12"
        >
          <project-files-title />
        </b-col>
        <b-col
          cols="12"
          md="12"
        >
          <project-files-notes-card />
        </b-col>
        <b-col
          cols="12"
          md="12"
        >
          <p-f-document-groups-select-card />
        </b-col>
        <b-col
          cols="12"
          md="12"
        >
          <project-files-file-card />
        </b-col>
      </b-row>
    </b-card>

  </div>
</template>

<script>
import {
  BCard, BRow, BCol,
} from 'bootstrap-vue'
import ProjectFilesTitle from '@/views/Projects/elements/ProjectFiles/Elements/TitleCard.vue'
import ProjectFilesNotesCard from '@/views/Projects/elements/ProjectFiles/Elements/NotesCard.vue'
import PFDocumentGroupsSelectCard from '@/views/Projects/elements/ProjectFiles/Elements/DocumentGroupsCard.vue'
import ProjectFilesFileCard from '@/views/Projects/elements/ProjectFiles/Elements/FileCard.vue'

export default {
  name: 'ProjectFilesItemForm',
  components: {
    ProjectFilesFileCard,
    PFDocumentGroupsSelectCard,
    ProjectFilesNotesCard,
    ProjectFilesTitle,
    BCard,
    BRow,
    BCol,
  },
  computed: {
    itemData() {
      return this.$store.getters['projectFiles/dataItem']
    },
  },
}
</script>
